export const LOCALE_NL = 'nl'
export const LOCALE_NL_BE = 'nl-BE'
export const LOCALE_NL_NL = 'nl-NL'
export const LOCALE_EN = 'en'
export const LOCALE_EN_GB = 'en-GB'
export const LOCAL_EN_US = 'en-US'
